module.exports = __webpack_public_path__ + "static/media/cardMaster.297e9922.jpg";